<!-- 新发基金解读 -->
<template>
  <div v-if="!$isEmpty(readInfo) && !$isEmpty(readInfo.content)" class="new-fund-read">
    <div class="title-line row">
      <div class="left row">
        <img :src="TITLE_IMG" class="title-img" />
        <img :src="TIP_ICON" class="tip-icon" />
        <div v-if="!$isEmpty(readInfo.title)" class="title"
          >{{readInfo.title}}</div>
      </div>
      <div class="right row">
        <div>更多</div>
        <img :src="RIGHT_ARROW" class="arrow" />
      </div>
    </div>
    <!-- 内容 -->
    <div class="content row">
      <div v-for="(text, index) in readInfo.content" :key="index">
        <div class="text-item">
          <div class="text-block">{{text}}</div>
          <div class="bg"></div>
          <div class="real-text">{{text}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

  name: 'new-fund-read',

  props: {
    cfhInfo: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      TITLE_IMG: 'https://j5.dfcfw.com/sc/image/202308/20230816071833.png',
      TIP_ICON: 'https://j5.dfcfw.com/sc/image/202110/20211009012345.png',
      RIGHT_ARROW: 'https://j5.dfcfw.com/sc/image/202305/20230529052234.png',
    };
  },

  computed: {
    readInfo() {
      return this.cfhInfo?.newFundRead[0] || {};
    },
  },
};
</script>

<style lang="less" scoped>
.new-fund-read {
  width: 100%;
  background-color: #ffffff;
  margin-top: 24px;
  margin-bottom: 24px;;
  box-sizing: border-box;
  padding: 40px 24px;
  border-radius: 12px;
  .row {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .title-line {
    justify-content: space-between;
    .left {
      width: calc(100% - 120px);
      .title {
        width: calc(100% - 160px);
        font-family: PingFangSC-Medium;
        font-size: 30px;
        color: #000000;
        white-space: nowrap; /* 不换行 */
        overflow: hidden; /* 超出部分隐藏 */
        text-overflow: ellipsis; /* 显示省略号 */
      }
      .title-img {
        width: 114px;
        height: 28px;
      }
      .tip-icon {
        width: 26px;
        height: 26px;
        margin-left: 8px;
        margin-right: 12px;
      }
    }
    .right {
      width: 120px;
      font-size: 28px;
      text-align: right;
      color: #666666;
      .arrow {
        width: 32px;
        height: 32px;
        margin-left: 2px;
      }
    }
  }
  .content {
    flex-wrap: wrap;
    margin-top: 20px;
    .text-item {
      font-size: 30px;
      color: #000000;
      position: relative;
      .text-block {
        opacity: 0;
      }
      .bg {
        width: 100%;
        height: 26px;
        background-color: #FCF1E4;
        position: absolute;
        bottom: 0;
      }
      .real-text {
        position: absolute;
        top: 0;
        left: 0;
      }
    }
  }
}
</style>
